import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-dynamic-theme-lib',
  template: `
    <p>
      dynamic-theme-lib works!
    </p>
  `,
  styles: [
  ]
})
export class DynamicThemeLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
